import { NameIdTuple, TreeNodeExtenededResponseMessageDTO } from 'business/models/Models';
import ETreeNodeTypes from 'enums/ETreeNodeTypes';
import React from 'react';

const messageFormatForScreen =
  ' is referenced by one or more experiments outside the scope of deletion and can not be deleted.\n\n';
const messageFormatForExperiment =
  ' contains one or more seeds which are outside the scope of deletion and can not be deleted.\n\n';
const messageFormatForFragment =
  ' is used by active experiments, please unlink this fragment from Experiment to delete';

const getErrorMessage = (errorMessage: string, nodeType: ETreeNodeTypes) => {
  if (errorMessage) {
    return errorMessage;
  } else {
    if (nodeType === ETreeNodeTypes.Experiment) {
      return messageFormatForExperiment;
    } else if (nodeType === ETreeNodeTypes.FragmentScreen) {
      return messageFormatForFragment;
    }
    return messageFormatForScreen;
  }
};
interface Props {
  deleteTreeNodes: NameIdTuple[];
  allUnDeletedNodes: TreeNodeExtenededResponseMessageDTO[];
}

const DeleteResponseModalBody = (props: Props) => {
  const { deleteTreeNodes: deleteTreeNodeIds, allUnDeletedNodes } = props;
  return (
    <>
      {deleteTreeNodeIds.length > 0 && (
        <div id='explorer-deleteresponsemodalbody-content' >
          The following files have been deleted.
          <br />
          {deleteTreeNodeIds.map((node: NameIdTuple, index) => (
            <div id={`explorer-deleteresponsemodalbody-deleted-item-${node.name}`} 
              className="ml-4" key={'deletedNode_' + index}>{`${index + 1}) ${
              node.name
            }`}</div>
          ))}
        </div>
      )}
      {allUnDeletedNodes.length > 0 && (
        <div id="explorer-deleteresponsemodalbody-notdeleted-title">
          These following files have not been deleted, hover to see details.
          {allUnDeletedNodes.map((node, index) => (
            <div id={`explorer-deleteresponsemodalbody-notdeleted-item-${index}`}
              className="text-red-800 ml-4"
              key={index}
              title={getErrorMessage(node.responseMessage, node.type as ETreeNodeTypes)}
            >
              {`${index + 1}) ${node.name}`}
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default DeleteResponseModalBody;
